// this file is automatically generated during docker build
export const versions = {version: '20260818.8-b234eb9', revision: 'b234eb9', branch: 'v2-cloud-client', dateTime:'2026-08-18T06:24'};